import React from 'react';

import { Box, Paper, Typography } from '@mui/material';
import { Button } from '@apigrowfinance/pbolt-button';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import ResetPeriodShared from '@pages/flexControls/shared/ResetPeriodForm';
import getEnumTranslation from '@utils/getEnumTranslation';

interface ResetPeriodProps {
    goToNextStep?: () => void;
    goToPreviousStep?: () => void;
}

const ResetPeriod = ({ goToNextStep, goToPreviousStep }: ResetPeriodProps) => {
    const { getValues } = useFormContext();

    const formValues = getValues();

    return (
        <Paper
            elevation={0}
            sx={{
                mt: 2,
                p: 2,
                pt: 7.5,
            }}>
            {formValues?.type !== 'restriction' ? (
                <ResetPeriodShared />
            ) : (
                <Box
                    justifyContent="center"
                    flexDirection="row"
                    display="flex"
                    sx={{ p: 2 }}>
                    <Typography variant="h6">
                        <FormattedMessage
                            id="ResetPeriod.noReset"
                            defaultMessage="Restriction controls can not have a reset period"
                        />
                    </Typography>
                </Box>
            )}
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                sx={{ mt: 2 }}>
                <Button
                    onClick={goToPreviousStep}
                    name="positive"
                    role="button"
                    variant="outlined"
                    disableElevation
                    data-testid="reset-period-form-previous-button"
                    sx={{
                        px: 8,
                        textTransform: 'none',
                    }}>
                    {getEnumTranslation('previous')}
                </Button>
                <Button
                    onClick={goToNextStep}
                    name="positive"
                    role="button"
                    variant="contained"
                    disableElevation
                    data-testid="reset-period-form-next-button"
                    sx={{
                        ml: 1,
                        px: 8,
                        textTransform: 'none',
                    }}>
                    {getEnumTranslation('next')}
                </Button>
            </Box>
        </Paper>
    );
};

export default ResetPeriod;
